import { fromEasternWallDate, toEasternWallDate } from './easternTime';

// The Eastern time of day of b, on a's Eastern calendar day (e.g. a picked yard time on the order's date).
export function adjustSecondDateToMatchFirst(a, b) {
    if (a == null || b == null) {
        return b;
    }

    const day = toEasternWallDate(a);
    const time = toEasternWallDate(b);

    return fromEasternWallDate(
        new Date(day.getFullYear(), day.getMonth(), day.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds())
    );
}
